import { produce } from "immer";
import {
  FETCH_BILLING_PLANS,
  FETCH_BILLING_PLANS_SUCCESS,
  FETCH_BILLING_PLANS_FAILURE,
  START_BILLING_CHECKOUT,
  START_BILLING_CHECKOUT_SUCCESS,
  START_BILLING_CHECKOUT_FAILURE,
  CONFIRM_BILLING_CHECKOUT,
  CONFIRM_BILLING_CHECKOUT_SUCCESS,
  CONFIRM_BILLING_CHECKOUT_FAILURE,
  CHANGE_BILLING_PLAN,
  CHANGE_BILLING_PLAN_SUCCESS,
  CHANGE_BILLING_PLAN_FAILURE,
  PREVIEW_BILLING_PLAN_CHANGE,
  PREVIEW_BILLING_PLAN_CHANGE_SUCCESS,
  PREVIEW_BILLING_PLAN_CHANGE_FAILURE,
  CLEAR_BILLING_PLAN_PREVIEW,
  CANCEL_BILLING,
  CANCEL_BILLING_SUCCESS,
  CANCEL_BILLING_FAILURE,
  UPDATE_BILLING_QUANTITY,
  UPDATE_BILLING_QUANTITY_SUCCESS,
  UPDATE_BILLING_QUANTITY_FAILURE,
} from "./constants";

export const initialState = {
  plans: [],
  subscriptions: [],
  location: null,
  grantedPlanCodes: [],
  isLoading: false,
  isBusy: false,
  isActivating: false,
  isPreviewing: false,
  planChangePreview: null,
};

const BillingReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_BILLING_PLANS:
        draft.isLoading = true;
        break;
      case FETCH_BILLING_PLANS_SUCCESS:
        draft.isLoading = false;
        draft.plans = Array.isArray(action.payload?.plans)
          ? action.payload.plans
          : [];
        draft.subscriptions = Array.isArray(action.payload?.subscriptions)
          ? action.payload.subscriptions
          : [];
        draft.location = action.payload?.location ?? null;
        draft.grantedPlanCodes = Array.isArray(action.payload?.granted_plan_codes)
          ? action.payload.granted_plan_codes
          : [];
        break;
      case FETCH_BILLING_PLANS_FAILURE:
        draft.isLoading = false;
        draft.plans = [];
        draft.subscriptions = [];
        draft.location = null;
        draft.grantedPlanCodes = [];
        break;

      case START_BILLING_CHECKOUT:
      case CHANGE_BILLING_PLAN:
      case CANCEL_BILLING:
      case UPDATE_BILLING_QUANTITY:
        draft.isBusy = true;
        break;
      case PREVIEW_BILLING_PLAN_CHANGE:
        draft.isPreviewing = true;
        draft.planChangePreview = null;
        break;
      case PREVIEW_BILLING_PLAN_CHANGE_SUCCESS:
        draft.isPreviewing = false;
        draft.planChangePreview = action.payload ?? null;
        break;
      case PREVIEW_BILLING_PLAN_CHANGE_FAILURE:
        draft.isPreviewing = false;
        draft.planChangePreview = null;
        break;
      case CLEAR_BILLING_PLAN_PREVIEW:
        draft.isPreviewing = false;
        draft.planChangePreview = null;
        break;
      case CONFIRM_BILLING_CHECKOUT:
        draft.isActivating = true;
        break;
      case CHANGE_BILLING_PLAN_SUCCESS:
      case CHANGE_BILLING_PLAN_FAILURE:
        draft.isBusy = false;
        draft.isPreviewing = false;
        draft.planChangePreview = null;
        break;
      case START_BILLING_CHECKOUT_SUCCESS:
      case START_BILLING_CHECKOUT_FAILURE:
      case CANCEL_BILLING_SUCCESS:
      case CANCEL_BILLING_FAILURE:
      case UPDATE_BILLING_QUANTITY_SUCCESS:
      case UPDATE_BILLING_QUANTITY_FAILURE:
        draft.isBusy = false;
        break;
      case CONFIRM_BILLING_CHECKOUT_SUCCESS:
      case CONFIRM_BILLING_CHECKOUT_FAILURE:
        draft.isActivating = false;
        break;

      default:
        return state;
    }
  });

export default BillingReducer;
